import pkg from '../../../../package.json'

export const APP_NAME = 'app_space'

export const APP_VERSION = pkg.version
